var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',[_vm._v("\n  "+_vm._s(_vm.$t('components.cremationsFormInstructions.toFinalise'))+" “\n  "),_c('strong',[_vm._v("\n    "+_vm._s(_vm.$t('components.cremationsFormInstructions.unknown'))+"\n  ")]),_vm._v("\n  ” "+_vm._s(_vm.$t('components.cremationsFormInstructions.toSelectAppropriate'))+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }